// import React from 'react'

const Email=()=>{
    return (
  <>
  <input type="text" placeholder="Email Id " className="Loan_Id_Input"></input> <br/>
  <p className="Instruction">Enter your Registered Email Address</p>
  <button className="Loan_Id_OTP">GET OTP</button>
  </>
    )    
  
  }
  
  export default Email;